import React from "react";
import PropTypes from "prop-types";

import SendForm from "../components/send-form-career";

const Cf7Contact = ({ url }) => {
  return <SendForm url={url} />;
};

Cf7Contact.propTypes = {
  url: PropTypes.string,
};

export default Cf7Contact;
